import React, { useState, useEffect } from "react";
import Section from "./layouts/Section";
import { WebLink, SiteWide } from "./customComponents";
import { useSelector, useDispatch } from 'react-redux';

import { authActions } from '../redux/actions';
import { userSelect, allRemoteSettingsSelect, homeScreenStatSelect } from '../redux/selectors/index';
import Helper1, { notify, money, customNormalModalStyles } from '../utility/Helper1';

import Countdown from 'react-countdown';

// MUI icons
import ShieldIcon from "@mui/icons-material/Shield";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LockIcon from "@mui/icons-material/Lock";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import RefreshIcon from "@mui/icons-material/Refresh";

function ChangePin({ history }) {

    const userData = useSelector(userSelect);
    const site_settings = useSelector(allRemoteSettingsSelect);
    const finance = useSelector(homeScreenStatSelect);

    const [withdrawalPin, setWithdrawalPin] = useState('');
    const [emailOTP, setEmailOTP] = useState('');

    const [showPin, setShowPin] = useState(false);
    const [showOTP, setShowOTP] = useState(false);

    const [loading, setloading] = useState();
    const [loadingText, setLoadingText] = useState('Loading...');

    const dispatch = useDispatch();

    const doWithdrawalPinChange = (e) => {
        e.preventDefault();
        setloading(true);
        setLoadingText('Changing Withdrawal PIN...');
        dispatch(authActions.onLogin(`account/withdrawal-pin/change`, { emailOTP, withdrawalPin }, response => {
            notify(response.msg, response.code);
            setloading(false);
            if (response.code == 1) { setWithdrawalPin(''); }
        }));
    };

    const getNewEmailOTP = () => {
        dispatch(authActions.onLogin(`account/send-email-otp/withdrawal-pin`, {}, response => { }));
    };

    useEffect(() => {
        getNewEmailOTP();
    }, []);

    // ── shared styles ──────────────────────────────────────────────────────────
    const inputWrap = { position: "relative" };

    const inputStyle = {
        width: "100%", borderRadius: 12, padding: "13px 44px 13px 14px",
        border: "1px solid rgba(59,130,246,0.15)",
        background: "#f8fafc", color: "#0f172a",
        fontSize: 14, fontFamily: "'DM Sans',sans-serif",
        outline: "none", boxSizing: "border-box",
        transition: "border 0.2s"
    };

    const labelStyle = {
        color: "#334155", fontSize: 12, fontWeight: 600,
        fontFamily: "'DM Sans',sans-serif",
        display: "block", marginBottom: 6
    };

    const eyeBtn = {
        position: "absolute", right: 12, top: "50%",
        transform: "translateY(-50%)", background: "none",
        border: "none", cursor: "pointer", color: "#94a3b8",
        display: "flex", alignItems: "center", padding: 0
    };

    const tips = [
        { text: "Choose a PIN that's easy to remember but hard to guess" },
        { text: "Avoid sequential numbers like 1234 or repeated digits" },
        { text: "Never share your PIN with anyone" },
        { text: "Change your PIN periodically for better security" },
    ];

    return (
        <SiteWide title="Change PIN">
            <Section loading={loading} overlayText={loadingText} title={'Change PIN'}>
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

                    {/* ── Header card ── */}
                    <div style={{
                        borderRadius: 16, padding: 20, position: "relative", overflow: "hidden",
                        background: "linear-gradient(135deg,#4c1d95 0%,#6d28d9 50%,#7c3aed 100%)",
                        border: "1px solid rgba(167,139,250,0.2)"
                    }}>
                        <div style={{
                            position: "absolute", top: 0, right: 0, opacity: 0.12,
                            width: 140, height: 140,
                            background: "radial-gradient(circle,#c4b5fd,transparent)",
                            borderRadius: "50%", transform: "translate(30px,-30px)"
                        }} />
                        <div style={{ display: "flex", alignItems: "center", gap: 14, position: "relative" }}>
                            <div style={{
                                width: 48, height: 48, borderRadius: 14,
                                background: "rgba(255,255,255,0.15)",
                                backdropFilter: "blur(8px)",
                                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                            }}>
                                <SmartphoneIcon style={{ color: "#ffffff", fontSize: 24 }} />
                            </div>
                            <div>
                                <p style={{ color: "#ffffff", fontSize: 16, fontWeight: 800, fontFamily: "'Syne',sans-serif", margin: 0 }}>
                                    Change PIN
                                </p>
                                <p style={{ color: "rgba(237,233,254,0.7)", fontSize: 12, fontFamily: "'DM Sans',sans-serif", margin: 0 }}>
                                    Update your withdrawal PIN securely via email OTP
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* ── Form card ── */}
                    <div style={{
                        background: "#ffffff", border: "1px solid rgba(59,130,246,0.08)",
                        boxShadow: "0 4px 18px rgba(59,130,246,0.04)", borderRadius: 16, padding: 20
                    }}>
                        <form onSubmit={doWithdrawalPinChange} style={{ display: "flex", flexDirection: "column", gap: 16 }}>

                            {/* New PIN */}
                            <div>
                                <label style={labelStyle}>New PIN</label>
                                <div style={inputWrap}>
                                    <input
                                        type={showPin ? 'text' : 'password'}
                                        value={withdrawalPin}
                                        onChange={(e) => setWithdrawalPin(e.target.value)}
                                        maxLength={4}
                                        placeholder="Enter new 4-digit PIN"
                                        style={inputStyle}
                                    />
                                    <button type="button" onClick={() => setShowPin(!showPin)} style={eyeBtn}>
                                        {showPin
                                            ? <VisibilityOffIcon style={{ fontSize: 18 }} />
                                            : <VisibilityIcon style={{ fontSize: 18 }} />}
                                    </button>
                                </div>
                                <p style={{ color: "#94a3b8", fontSize: 11, fontFamily: "'DM Sans',sans-serif", margin: "5px 0 0" }}>
                                    PIN must be exactly 4 digits
                                </p>
                            </div>

                            {/* Email OTP */}
                            <div>
                                <label style={labelStyle}>Email OTP</label>
                                <div style={inputWrap}>
                                    <input
                                        type={showOTP ? 'text' : 'password'}
                                        value={emailOTP}
                                        onChange={(e) => setEmailOTP(e.target.value)}
                                        placeholder="Enter OTP from your email"
                                        style={inputStyle}
                                    />
                                    <button type="button" onClick={() => setShowOTP(!showOTP)} style={eyeBtn}>
                                        {showOTP
                                            ? <VisibilityOffIcon style={{ fontSize: 18 }} />
                                            : <VisibilityIcon style={{ fontSize: 18 }} />}
                                    </button>
                                </div>

                                {/* OTP hint row with resend timer */}
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 6 }}>
                                    <p style={{ color: "#94a3b8", fontSize: 11, fontFamily: "'DM Sans',sans-serif", margin: 0 }}>
                                        OTP sent to your registered email
                                    </p>
                                    <Countdown
                                        zeroPadTime={2}
                                        key={new Date(userData?.withdrawalPinResetTime ?? 0)}
                                        date={new Date(userData?.withdrawalPinResetTime ?? 0)}
                                        renderer={({ hours, minutes, seconds, completed }) => {
                                            if (completed) {
                                                return (
                                                    <button
                                                        type="button"
                                                        onClick={getNewEmailOTP}
                                                        style={{
                                                            background: "none", border: "none",
                                                            color: "#2563eb", fontSize: 11,
                                                            fontWeight: 600, fontFamily: "'DM Sans',sans-serif",
                                                            cursor: "pointer", display: "flex",
                                                            alignItems: "center", gap: 4, padding: 0
                                                        }}
                                                    >
                                                        <RefreshIcon style={{ fontSize: 13 }} />
                                                        Resend OTP
                                                    </button>
                                                );
                                            } else {
                                                return (
                                                    <span style={{ color: "#64748b", fontSize: 11, fontFamily: "'DM Sans',sans-serif" }}>
                                                        Resend in {minutes}:{seconds}
                                                    </span>
                                                );
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            {/* OTP info notice */}
                            <div style={{
                                background: "rgba(59,130,246,0.04)", border: "1px solid rgba(59,130,246,0.12)",
                                borderRadius: 12, padding: "10px 14px",
                                display: "flex", alignItems: "center", gap: 10
                            }}>
                                <MarkEmailReadIcon style={{ color: "#3b82f6", fontSize: 18, flexShrink: 0 }} />
                                <p style={{ color: "#334155", fontSize: 12, fontFamily: "'DM Sans',sans-serif", margin: 0 }}>
                                    An OTP was sent automatically when you opened this page. Check your email inbox.
                                </p>
                            </div>

                            {/* Submit */}
                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    width: "100%", borderRadius: 12, padding: "13px 0", border: "none",
                                    background: loading
                                        ? "rgba(109,40,217,0.3)"
                                        : "linear-gradient(135deg,#7c3aed,#6d28d9)",
                                    color: "#fff", fontSize: 14, fontWeight: 700,
                                    fontFamily: "'Syne',sans-serif", cursor: loading ? "not-allowed" : "pointer",
                                    boxShadow: loading ? "none" : "0 4px 16px rgba(109,40,217,0.25)",
                                    marginTop: 4
                                }}
                            >
                                {loading ? 'Updating...' : 'Update PIN'}
                            </button>
                        </form>
                    </div>

                    {/* ── Security tips ── */}
                    <div style={{
                        background: "#ffffff", border: "1px solid rgba(59,130,246,0.08)",
                        boxShadow: "0 2px 12px rgba(59,130,246,0.02)", borderRadius: 16, padding: 20
                    }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                            <div style={{
                                width: 36, height: 36, borderRadius: 10,
                                background: "rgba(109,40,217,0.08)", border: "1px solid rgba(109,40,217,0.15)",
                                display: "flex", alignItems: "center", justifyContent: "center"
                            }}>
                                <ShieldIcon style={{ color: "#7c3aed", fontSize: 18 }} />
                            </div>
                            <p style={{ color: "#0f172a", fontSize: 13, fontWeight: 700, fontFamily: "'Syne',sans-serif", margin: 0 }}>
                                PIN Security Tips
                            </p>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            {tips.map((tip, i) => (
                                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                                    <CheckCircleIcon style={{ color: "#22c55e", fontSize: 15, marginTop: 1, flexShrink: 0 }} />
                                    <p style={{ color: "#475569", fontSize: 12, fontFamily: "'DM Sans',sans-serif", margin: 0, lineHeight: 1.5 }}>
                                        {tip.text}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </Section>
        </SiteWide>
    );
}

export default ChangePin;